import { Injectable } from '@angular/core';
import { Company } from 'app/interfaces/company';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  private Company = new Subject<Company[]>();
  private companySubject = new Subject<Company>();
  private Selected: Company;
  constructor(
    private httpClient: HttpClient
  ) { }


  fetchCompany(): Observable<Company[]> {
    this.httpClient.get<Company[]>(`/company`).subscribe(
      (data: Company[]) => {
        this.Company.next(data)
      }, error => {
        console.log('fetchCompany error', error)
      })
    return this.Company.asObservable()
  }

  companySelected(company: Company): void {
    this.Selected = company;
  }

  getCompanySelected(): Company {
    return this.Selected;
  }

  setCompanySubject(company: Company): void {
    console.log('SubjectCompany')
    this.companySubject.next(company);
  }

  getCompanyAsObservable(): Observable<Company> {
    return this.companySubject.asObservable();
  }

  getNotificationCount(tokenId: string): Observable<any> {
    const url = `/approvals?tokenId=${tokenId}`
    return this.httpClient.get<any>(url)
  }

  getPendencyList(tokenId: string): Observable<any> {
    const url = `/approvals/list?tokenId=${tokenId}`
    return this.httpClient.get<any>(url)
  }
}
